/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC Skew Plotter — Toolverse`)
};

const es_gcskew_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graficador de Sesgo GC — Toolverse`)
};

const de_gcskew_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-Skew-Plotter — Toolverse`)
};

const nl_gcskew_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-skewplotter — Toolverse`)
};

const fr_gcskew_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traceur de biais GC (GC skew) — Toolverse`)
};

const it_gcskew_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafico dello skew GC — Toolverse`)
};

const pt_br2_gcskew_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plotador de GC Skew — Toolverse`)
};

const pt_gcskew_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráfico de Assimetria GC — Toolverse`)
};

const ja_gcskew_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GCスキュープロッター — Toolverse`)
};

const zh_gcskew_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC 偏斜绘图工具 — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_meta_title", locale)
	if (locale === "en") return en_gcskew_meta_title(inputs)
	if (locale === "es") return es_gcskew_meta_title(inputs)
	if (locale === "de") return de_gcskew_meta_title(inputs)
	if (locale === "nl") return nl_gcskew_meta_title(inputs)
	if (locale === "fr") return fr_gcskew_meta_title(inputs)
	if (locale === "it") return it_gcskew_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_meta_title(inputs)
	if (locale === "pt") return pt_gcskew_meta_title(inputs)
	if (locale === "ja") return ja_gcskew_meta_title(inputs)
	return zh_gcskew_meta_title(inputs)
};